
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import { APP_CONFIG } from '@/config/app-config';

import u from '@/utility/utility';

import BillOfLading from './components/BillOfLading.vue';
import DeliveryInfo from './components/DeliveryInfo.vue';

import { Lading } from '@/models/bill-of-lading';
import { Customer } from '@/models/customer';

import authService from '@/services/auth-services';
import commonService from '@/services/common-services';
import depositService from '@/services/deposit-services';

@Component({
    components: {
        Loading,
        'bill-of-lading': BillOfLading,
        'delivery-info': DeliveryInfo
    }
})
export default class AddNewDeposit extends Vue {
    private listLadings: Lading[] = [];
    private customerInfo: Customer = {};
    private isLoading = false;
    private isFragileGoods = false;
    private isCheckA = false;
    private isCheckB = false;
    private guaranteeType = 0;

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get customerLevels() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].customerLevels;
    }

    get customerLevelsDiscount() {
        return this.customerLevels.find((cl) => cl.ID === (this.customerInfo.LevelID || 1));
    }

    get rate() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

    get feeGuarantee() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].feeGuarantee;
    }

    get lineType() {
        return APP_CONFIG.lineType;
    }

    private async getFeeGuarantee() {
        const result = await commonService.getFeeGuarantee();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_FEEGUARANTEE', result.data.data);
        }
    }

    @Watch('isCheckA', { immediate: true, deep: true })
    private async watchIsCheckA() {
        if (this.isCheckA) {
            this.isCheckB = false;
        }
    }

    @Watch('isCheckB', { immediate: true, deep: true })
    private async watchIsCheckB() {
        if (this.isCheckB) {
            this.isCheckA = false;
        }
    }

    private async created() {
        this.getRate();
        this.getCustomersInfo();
        this.addNewGood();

        if (!this.customerLevels) {
            await this.getCustomerLevels();
        }
        if (!this.feeGuarantee) {
            await this.getFeeGuarantee();
        }
    }

    private async getRate() {
      const result = await commonService.exchangeRate();
      if (result && result.status === 200) {
        (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
        (window['getApp'] as any).$emit('SET_MIN_FEEBUY', result.data.data.min_feebuy);
      }
    }

    private async getCustomersInfo() {
        if (this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if(result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
                this.customerInfo = {
                    ...result.data.data
                };
            }
        }
    }

    private async getCustomerLevels() {
        const result = await commonService.getCustomerLevels();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CUSTOMER_LEVELS', result.data.data);
        }
    }

    private async onAddRow(data: any) {
        this.checkValid();
        if (this.listLadings.filter(x => x.isValid === false).length > 0) {
            return false;
        }

        this.addNewGood();
    }

    private async submitDeposit() {
        if (!this.checkValid()) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Hãy điền đầy đủ thông tin vận đơn!',
            });
            return false;
        }

        this.isLoading = true;
        const dataRequest = {
            UID: this.userInfo.userId,
            Username: this.userInfo.userName,
            Status: 16,
            FeeWeightCK: this.customerLevelsDiscount ? this.customerLevelsDiscount.WeightDiscount : 0,
            ReceivePlaceID: this.customerInfo.ReceivePlaceID,
            ChinaStoreID: this.customerInfo.ChinaStoreID,
            CustomerServiceID: this.customerInfo.CustomerServiceID,
            CurentCNYVN: this.rate,
            IsFragileGoods: this.isFragileGoods,
            CheckFeeType: this.isCheckA ? 1 : this.isCheckB ? 2 : 0,
            GuaranteeType: this.guaranteeType,
            IsCheck: this.isCheckA || this.isCheckB,
            LineType: this.lineType,
            Transactions: [
                ...this.listLadings.map(x => {
                    return {
                        TransactionCode: x.binCode,
                        ProductName: x.productName,
                        ProductAmount: x.productAmount,
                        NumberOfPack: x.numberOfPack,
                        ProductNumber: x.productNumber,
                        Status: 1
                    }
                })
            ]
        };

        const result = await depositService.createDeposit(dataRequest);
        this.isLoading = false;
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Tạo mới ký gửi thành công!',
            });
            this.$router.push({ name: 'deposit-detail', params: { id: result.data.data.ID.toString() } }).catch(() => {
                return false;
            });
        } else if (result && result.data.status === 202) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: result.data.error,
            });
        } else {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Có lỗi trong quá trình xử lý dữ liệu!',
            });
        }
    }

    private async onRemoveRow(id: string) {
        this.listLadings = this.listLadings.filter(x => x.id !== id);
    }

    private async addNewGood() {
        const item = new Lading();
        this.listLadings.push(item);
    }

    private checkValid() {
        this.listLadings = this.listLadings.map(good => {
            if (u.isNullOrWhitespace(good.binCode)) {
                good.isValid = false;
            } else {
                good.isValid = true;
            }
            return good;
        });

        return !(this.listLadings.filter(x => x.isValid === false).length > 0);
    }
}
